
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth-consume/ad",
      function () {
        return require("private-next-pages/auth-consume/ad.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth-consume/ad"])
      });
    }
  